// extracted by mini-css-extract-plugin
module.exports = {"date":"case-info-and-link-module--date--3f1re","link":"case-info-and-link-module--link--3lFqz","linkIcon":"case-info-and-link-module--linkIcon--1iZsv"};